(function () {
  // Only run on the Bracelet Tool product page
  const productId = 11218049859926;
  const currentProductId = window.__st?.pid;
  if (currentProductId !== productId) return;

  const form = document.querySelector('form[action="/cart/add"]');
  if (!form) return;

  // Create error message element
  const errorMsg = document.createElement('p');
  errorMsg.id = 'bracelet-tool-error';
  errorMsg.style.cssText = 'color:#c0392b; margin-top:12px; font-size:0.9em; display:none;';
  errorMsg.textContent = 'The Bracelet Tool can only be added alongside a bracelet. Please add a bracelet to your cart first.';
  form.appendChild(errorMsg);

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    // Fetch current cart
    const response = await fetch('/cart.js');
    const cart = await response.json();

    // Check for any item tagged 'bracelet'
    const hasBracelet = cart.items.some(item =>
      item.tags && item.tags.toLowerCase().includes('bracelet')
    );

    if (!hasBracelet) {
      errorMsg.style.display = 'block';
      return;
    }

    errorMsg.style.display = 'none';
    form.submit();
  });
})();
